import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/hooks/useAuth';
import { keys } from '@/lib/queryKeys';
import { fetchBillItems } from './api';

/** A bill's own lines — what the "Issue credit note" dialog picks from. */
export function useBillItems(billId: number | null) {
  const { branchVersion } = useAuth();
  return useQuery({
    queryKey: [...keys.billing.items(billId ?? 0), branchVersion],
    queryFn: () => fetchBillItems(billId as number),
    enabled: billId != null,
  });
}
